import {
  ReactElement,
  useState,
  useEffect,
  useRef,
  Children,
  cloneElement,
  ReactNode,
} from "react";
import { ToolSelectorButton } from "./ToolSelectorButton";
import ChatGPT from "../Images/ChatGPT.png";
import Claude from "../Images/Claude.png";
import Gemini from "../Images/Gemini.png";
import Grok from "../Images/Grok.png";
import TradingView from "../Images/TradingView.png";
import StableDiffusion from "../Images/StableDiffusionLogo.png";
import MathLogo from "../Images/MathTutor.png";
import "../css/enlive.css";
import SwipeableSection from "./organisms/swiper/MobileSwiper";

interface ToolSelectorProps {
  onToolSelect: (tool: string) => void;
  className?: string;
}

export function ToolSelector({
  onToolSelect,
  className = "",
}: ToolSelectorProps): ReactElement {
  return (
    <div className={`mt-3 ${className}`}>
      <SwipeableSection title="General">
        <ToolSelectorButton
          className="tool-name"
          toolName="ChatGPT"
          image={ChatGPT}
          onClick={() => onToolSelect("ChatGPT")}
        />
        <ToolSelectorButton
          className="tool-name"
          toolName="Claude"
          image={Claude}
          onClick={() => onToolSelect("Claude")}
        />
        <ToolSelectorButton
          className="tool-name"
          toolName="Grok"
          image={Grok}
          onClick={() => onToolSelect("Grok")}
        />
        <ToolSelectorButton
          className="tool-name"
          toolName="Gemini"
          image={Gemini}
          onClick={() => onToolSelect("Gemini")}
        />
      </SwipeableSection>

      <SwipeableSection title="Special">
        <ToolSelectorButton
          className="tool-name"
          toolName="TradingView"
          image={TradingView}
          onClick={() => onToolSelect("TradingView")}
        />
        <ToolSelectorButton
          className="tool-name"
          toolName="Stable Diffusion"
          image={StableDiffusion}
          onClick={() => onToolSelect("Stable Diffusion")}
        />
        <ToolSelectorButton
          className="tool-name"
          toolName="Math Tutor"
          image={MathLogo}
          onClick={() => onToolSelect("Math")}
        />
      </SwipeableSection>
    </div>
  );
}
